<template>
    <Dialog title="登录">
      <InputBox placeholder="请输入你的账号" mb="0.2rem" v-model="username"/>
      <InputBox placeholder="请输入你的密码" mb="0.2rem" v-model="password" type="password"/>
      <div class="confirm" @click="handleLogin">确定</div>
      <div class="cancle" @click="handleClose"></div>
    </Dialog>
</template>

<script>
import Dialog from "./Dialog";
import InputBox from "./inputBox";
import jsencrypt from "jsencrypt";
import qs from "qs";
import {login} from '../utils/config'
let encry = new jsencrypt();
encry.setPublicKey(
  "MFwwDQYJKoZIhvcNAQEBBQADSwAwSAJBAI6uOzpfsQ1ScFPt6QPBNYFLIxm/yJC4/7UtLcbZAYeB2Wz85mzaNnaQuKb4nkGC1ltcRKukztWRRKA+gVBOt5cCAwEAAQ=="
);
export default {
  components: {
    Dialog,
    InputBox,
  },
  data: () => ({
    username: "",
    password: ""
  }),
  methods: {
    handleClose() {
      this.$emit("cancle", { type: "login" });
    },
    handleLogin() {
      if(!this.username || !this.password){
        this.$emit('prompt',"请填写完整的用户名和密码")
        return;
      }
      let db = {
        account: encry.encrypt(this.username),
        password: encry.encrypt(this.password)
      };
      this.$axios({
        withCredentials: true,
        crossDomain: true,
        method: "post",
        transformRequest: [
          function(data) {
            // 对 data 进行任意转换处理
            return qs.stringify(data);
          }
        ],
        url: login,
        data: db
      }).then(res => {
        let { data } = res;
        if (data.code == 0) {
          this.$emit("cancle", { type: "login", msg: data.data });
        } else {
          this.$emit('prompt',"账号或密码错误")
        }
      });
    }
  }
};
</script>

<style scoped>
.cancle {
  position: absolute;
  bottom: -132px;
  left: 50%;
  transform: translateX(-50%);
  width: 50px;
  height: 50px;
  background: url("../assets/guanbi.png") no-repeat;
  background-size: 100% 100%;
}
.confirm {
  width: 100%;
  height: 110px;
  background: #ffdf32;
  text-align: center;
  line-height: 110px;
  font-size: 32px;
  color: #000;
  border-radius: 8px;
}
</style>
